import { AnyAction, Dispatch } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse } from 'axios';
import { STORE_ERROR_FILES_UPLOADED, STORE_ERROR_FILES_UPLOADED_MSG } from 'src/reducers/errors';
import { downloadStatusUpdate } from './completeOrderAction';

export const downloadMessageAttachment = (filetodownload: string, ociStatus: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const filePath = encodeURIComponent(filetodownload);

        let downloadFrom = 'getDownloadUrl';

        if (ociStatus && ociStatus === '1') {
            downloadFrom = 'getODownloadUrl';
        }

        await axios({
            method: 'get',
            url: `${getState().environment.API_URL}${downloadFrom}?fullPath=${filePath}`,
        }).then(function (response: AxiosResponse) {
            // attachfilename
            window.open(response.data.signedUrl);
        }).catch(function (error: AxiosResponse) {
            // ==> console.error(error);
        });

    };
};

// export const downloadOrderFile = (filePath: string, fileName: string, status: string, ociStatus: string, orderno: string) => {
//     return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//         let fullPath = filePath;
//         console.log(filePath, 'filePathfilePathfilePathfilePath');
//         console.log(fileName, 'fileName');
//         console.log(status, 'status');
//         console.log(ociStatus, 'ociStatus');
//         console.log(orderno, 'orderno');     
//         let updateDownloadStatus: boolean = false;

//         if (status.includes('STL') || status.includes('Final')) {
//             updateDownloadStatus = true;
//         }

//         if (status.includes('Final')) {

//             if (filePath.indexOf('/Initial') !== -1) {
//                 fullPath = `${filePath.split('/Initial')[0]}/Final_Scan/${fileName}`;
//             } else if (filePath.indexOf('/Final') !== -1) {
//                 fullPath = `${filePath}/${fileName}`;
//             } else {
//                 fullPath = `${filePath}/Final_Scan/${fileName}`;
//             }

//         } else {
//             fullPath = `${filePath}/${fileName}`;
//         }
//         console.log(fullPath, 'ddddddddddddddddd');
        
//         const encodedFilepath = encodeURIComponent(fullPath);

//         let downloadFrom = 'getDownloadUrl';
//         if (ociStatus && ociStatus === '1') {
//             downloadFrom = 'getODownloadUrl';
//         }

//         axios(`${getState().environment.API_URL}${downloadFrom}?fullPath=${encodedFilepath}`, {
//             method: 'GET',
//             headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//                 sessionid: getState().user.userDetails.s || ''
//             }
//         }).then(response => {

//             window.open(response.data.signedUrl);

//             if (updateDownloadStatus) {
//                 const orderNoArr = [{
//                     orderno
//                 }];
//                 downloadStatusUpdate(orderNoArr, '1', dispatch, getState);
//             }

//         }).catch(error => {

//             const errorFileUploadedOpen = true;
//             const errorfilemsg = 'Something went wrong!';
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//             dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//             // ==> console.error(error);
//         });

//         return true;
//     };
// };

export const downloadOrderFile = (filePath: string, fileName: string, status: string, ociStatus: string, orderno: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        let fullPath = filePath;
    
        let updateDownloadStatus: boolean = false;

        if (status.includes('STL') || status.includes('Final')) {
            updateDownloadStatus = true;
        }

        if (status.includes('Final')) {

            if (filePath.indexOf('/Initial') !== -1) {
                fullPath = `${filePath.split('/Initial')[0]}/Final_Scan/${fileName}`;
            } else if (filePath.indexOf('/Final') !== -1) {
                fullPath = `${filePath}/${fileName}`;
            } else {
                fullPath = `${filePath}/Final_Scan/${fileName}`;
            }

        } else {
            fullPath = `${filePath}/${fileName}`;
        }
        
        const encodedFilepath = encodeURIComponent(fullPath);

        // let downloadFrom = 'getDownloadUrl';
        // if (ociStatus && ociStatus === '1') {
        //     downloadFrom = 'getODownloadUrl';
        // }
        const downloadFrom = 'commonBucketFileCheck';

        axios(`${getState().environment.API_URL}${downloadFrom}?fullPath=${encodedFilepath}`, {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                sessionid: getState().user.userDetails.s || ''
            }
        }).then(response => {

            window.open(response.data.signedUrl);

            if (updateDownloadStatus) {
                const orderNoArr = [{
                    orderno
                }];
                downloadStatusUpdate(orderNoArr, '1', dispatch, getState);
            }

        }).catch(error => {

            const errorFileUploadedOpen = true;
            const errorfilemsg = 'Something went wrong!';
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

            // ==> console.error(error);
        });

        return true;
    };
};
export const getSignerUrlforOrder = (orderno: string[]) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const filePath = encodeURIComponent(orderno.join());

        await axios({
            method: 'get',
            url: `${getState().environment.API_URL}getSignerUrlforOrder?fullPath=${filePath}`,
        }).then(function (response: AxiosResponse) {
            // attachfilename
            window.open(response.data.signedUrl);
        }).catch(function (error: AxiosResponse) {
            // ==> console.error(error);
        });

    };
};



// WEBPACK FOOTER //
// ./src/actions/filedownloadAction.ts